export default function authHeader() {
  let user = JSON.parse(localStorage.getItem("user"));
  let token = localStorage.getItem("jwt_token");

  let finalToken = user?.token || token;

  return {
    Authorization: "Bearer " + finalToken,
    "Content-Type": "multipart/form-data",
  };
}
